import React, { useEffect, useState } from 'react';
import { Box, Stack, Typography } from '@mui/material';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import { appleTokens as t } from '../../theme/appleTokens';
import { clubLogoUrl, useClubPublicConfig } from '../../services/clubPublicConfig';
import { formatClubDateTime } from '../../utils/clubFormat';
import PinPad from './ui/PinPad';

function useNow() {
  const [now, setNow] = useState(() => new Date());
  useEffect(() => {
    const id = setInterval(() => setNow(new Date()), 15 * 1000);
    return () => clearInterval(id);
  }, []);
  return now;
}

/**
 * Écran verrouillé de l'ERP (bouton cadenas de la barre du haut) : couvre toute l'application, dialogs compris, et
 * reste affiché après un rechargement. Déverrouillage par le code ERP « écran » (Configuration → Comptes & sécurité),
 * vérifié par l'API. Protection d'usage (poste laissé sans surveillance), pas une barrière de sécurité : la session
 * de l'utilisateur reste ouverte.
 */
export default function LockScreen({ onVerify, onUnlocked, who }) {
  const now = useNow();
  const config = useClubPublicConfig();
  const logo = clubLogoUrl(config, 'white');
  const clubName = config?.['club.name'] || '';

  return (
    <Box
      role="dialog"
      aria-modal="true"
      aria-label="Écran verrouillé"
      sx={{
        position: 'fixed',
        inset: 0,
        zIndex: 3000,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        bgcolor: 'rgba(14, 16, 22, 0.78)',
        backdropFilter: 'blur(18px)',
        color: '#fff',
        p: 2,
      }}
    >
      <Stack alignItems="center" spacing={3}>
        {logo ? (
          <Box component="img" src={logo} alt={clubName} sx={{ height: 44, maxWidth: 220, objectFit: 'contain' }} />
        ) : clubName ? (
          <Typography sx={{ ...t.type.sectionTitle, color: '#fff' }}>{clubName}</Typography>
        ) : null}
        <Stack alignItems="center" spacing={0.25}>
          <Typography sx={{ fontSize: 56, fontWeight: 600, lineHeight: 1, ...t.type.numeric, color: '#fff' }}>
            {formatClubDateTime(now, { hour: '2-digit', minute: '2-digit' })}
          </Typography>
          <Typography sx={{ ...t.type.body, color: 'rgba(255,255,255,0.7)', textTransform: 'capitalize' }}>
            {formatClubDateTime(now, { weekday: 'long', day: 'numeric', month: 'long' })}
          </Typography>
        </Stack>
        <Stack direction="row" spacing={1} alignItems="center" sx={{ color: 'rgba(255,255,255,0.8)' }}>
          <LockOutlinedIcon sx={{ fontSize: 18 }} />
          <Typography sx={{ ...t.type.small, color: 'inherit' }}>Écran verrouillé{who ? ` · ${who}` : ''}</Typography>
        </Stack>
        <PinPad
          dark
          onSubmit={async (code) => {
            const ok = await onVerify(code);
            if (ok) onUnlocked();
            return ok;
          }}
        />
      </Stack>
    </Box>
  );
}
